import { useState, type FormEvent } from 'react';
import { BrandMark, LegalLinks } from '../components/Chrome.tsx';

/**
 * Die Passwortseite vor der ganzen App -- siehe lib/gate.tsx. Bewusst ohne
 * Kopfleiste, Router und Konto: davon soll vor der Freigabe nichts laden.
 */
export function GatePage({ onOpen }: { onOpen: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await fetch('/api/gate', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const body = (await res.json().catch(() => ({}))) as { error?: string };
      if (!res.ok) throw new Error(body.error ?? `HTTP ${res.status}`);
      onOpen();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Hat nicht geklappt.');
      setPassword('');
      setBusy(false);
    }
  };

  return (
    <main className="gate">
      <form className="card gate__card" onSubmit={submit}>
        <div className="gate__brand">
          <BrandMark />
          Last Stream Standing
        </div>
        <h1 className="gate__title">Noch nicht öffentlich</h1>
        <p className="gate__lede">Last Stream Standing ist gerade in der Testphase. Mit dem Zugangspasswort geht es weiter.</p>

        <div className="field">
          <label htmlFor="gate-password">Zugangspasswort</label>
          <input
            id="gate-password"
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            autoFocus
            required
          />
        </div>

        {error && <div className="notice">{error}</div>}

        <button className="btn btn--lg btn--block" type="submit" disabled={busy || !password}>
          {busy ? 'Moment …' : 'Weiter'}
        </button>
        <p className="hint gate__hint">Gilt, bis du den Browser schließt.</p>
      </form>
      <LegalLinks plain />
    </main>
  );
}
